import ln from './locale';
import bus from './bus';

function changeBehaviorLang() {
  const symbol = {
    $gt: '>',
    $ge: '>=',
    $lt: '<',
    $le: '<=',
    $between: '介于(含边界值)',
  };

  const obj = {
    // 通用关系符号
    symbol,
    // 启动次数
    startTimes: {
      title: ln[bus.lang].userBehavior.startTimes.title, // 名称
      unit: ln[bus.lang].userBehavior.startTimes.unit, // 单位
      defaultValue: 'total_start_times', // 默认value
      defaultSymbol: '$gt', // 默认关系符号
      defaultNumber: '1', // 默认数值
      value: { // value内容
        total_start_times: ln[bus.lang].userBehavior.startTimes.totalStartTimes,
        avg_start_times_day: ln[bus.lang].userBehavior.startTimes.dailyStartAvg,
        min_start_times_day: ln[bus.lang].userBehavior.startTimes.dailyStartMin,
        max_start_times_day: ln[bus.lang].userBehavior.startTimes.dailyStartMax,
      },
    },
    // 使用时长
    useTimes: {
      title: ln[bus.lang].userBehavior.userTimes.title,
      unit: ln[bus.lang].userBehavior.userTimes.unit,
      value: {
        total_start_times: ln[bus.lang].userBehavior.userTimes.userTimes,
        avg_use_times: '单次使用时长均值',
      },
    },
    // 活跃情况
    launch_info: {
      title: ln[bus.lang].userBehavior.launch_info.title,
      unit: ln[bus.lang].userBehavior.launch_info.unit,
      value: {
        launch_info: ln[bus.lang].userBehavior.launch_info.launchDays,
      },
    },
    // 流失用户
    lostDays: {
      title: ln[bus.lang].userBehavior.lostDays.title,
      unit: ln[bus.lang].userBehavior.lostDays.unit,
      defaultValue: 'lost_user',
      defaultNumber: '3',
      defaultSymbol: '$gt',
      number: {
        3: '3',
        7: '7',
        15: '15',
        30: '30',
      },
    },
    // 事件
    customevent: {
      title: ln[bus.lang].userBehavior.customevent.title,
    },
    // 页面
    page_view: {
      title: ln[bus.lang].userBehavior.page_view.title,
    },
  };
  return obj;
}

const userLang = {};
userLang.changeBehaviorLang = changeBehaviorLang;

export default userLang;
